import { render } from "./PolarAreaChart.vue?vue&type=template&id=96740ef4&scoped=true"
import script from "./PolarAreaChart.vue?vue&type=script&lang=js"
export * from "./PolarAreaChart.vue?vue&type=script&lang=js"

import "./PolarAreaChart.vue?vue&type=style&index=0&id=96740ef4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96740ef4"]])

export default __exports__